export const muiStepper = {
  styleOverrides: {
    root: {
      background: 'transparent',
    },
  },
};
